import inviteBanner from "./inviteBanner";
import discountBanner from "./discountBanner";
import propertyBanner from "./propertyBanner";
import thankYouBanner from "./thankYouBanner"
import landingBanner from "./landingBanner"

export default {
  inviteBanner,
  discountBanner,
  propertyBanner,
  thankYouBanner,
  landingBanner
}